<template>
    <div class="app no-header">
        <w-questions @save="submit"
                     :answers="answers"
                     :message-show="message.show"
                     :sections="['pool_name', 'other_questions', 'equipment', 'address']"/>
    </div>
</template>

<script>

import { lambda } from '../aws'

export default {
    name: 'Questions',
    props: ['pool_id'],
    data () {
        return {
            message: {
                type: 'info',
                text: 'Your answers have been updated',
                show: false
            },
            curPool: null,
            answers: {
                label: '',
                waterBodyId: this.$route.params.pool_id,
                addr1: '',
                addr2: '',
                city: '',
                state: '',
                zip: ''
            }
        }
    },
    methods: {
        filterChanged (data) {
            let payload = {}
            for (let key in data) {
                if (data.hasOwnProperty(key)) {
                    if ((this.answers[key] !== undefined && data[key].toString() !== this.answers[key].toString()) || key === 'waterBodyId') {
                        payload[key] = data[key]
                        if (key === 'measDoseMin') payload.measDoseHr = data.measDoseHr
                        if (key === 'measDoseHr') payload.measDoseMin = data.measDoseMin
                    }
                }
            }
            if (payload.zip) payload.zip = parseInt(payload.zip)
            return payload
        },
        submit (data) {
            lambda('updateWaterBody', {
                waterBody: this.filterChanged(data)
            }).then(data => {
                if (data.code === 'OK') {
                    this.message.show = true
                    setTimeout(() => {
                        this.message.show = false
                    }, 5000)
                }
            })
        },
        getAnswers () {
            lambda('getWaterBody', {
                waterBodyId: this.$route.params.pool_id
            }).then(data => {
                if (!data) return
                this.curPool = data.waterBody
                if (this.curPool) {
                    for (let key in this.curPool) this.$set(this.answers, key, this.curPool[key])
                }
                this.$stopSpinner()
            })
        }
    },
    watch: {
        $route: {
            deep: true,
            handler () {
                this.getAnswers()
            }
        }
    },
    created () {
        this.getAnswers()
    }
}
</script>

<style scoped>
    .app {
        max-width: 530px;
        margin: 0 auto;
        padding-left: 17px;
        padding-right: 17px;
    }
</style>
